var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_710_67250",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_710_67250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 13C12.9 13 11.9583 12.6083 11.175 11.825C10.3917 11.0417 10 10.1 10 9C10 7.9 10.3917 6.95833 11.175 6.175C11.9583 5.39167 12.9 5 14 5C15.1 5 16.0417 5.39167 16.825 6.175C17.6083 6.95833 18 7.9 18 9C18 10.1 17.6083 11.0417 16.825 11.825C16.0417 12.6083 15.1 13 14 13ZM9 23C7.9 23 6.95833 22.6083 6.175 21.825C5.39167 21.0417 5 20.1 5 19C5 17.9 5.39167 16.9583 6.175 16.175C6.95833 15.3917 7.9 15 9 15C10.1 15 11.0417 15.3917 11.825 16.175C12.6083 16.9583 13 17.9 13 19C13 20.1 12.6083 21.0417 11.825 21.825C11.0417 22.6083 10.1 23 9 23ZM19 23C17.9 23 16.9583 22.6083 16.175 21.825C15.3917 21.0417 15 20.1 15 19C15 17.9 15.3917 16.9583 16.175 16.175C16.9583 15.3917 17.9 15 19 15C20.1 15 21.0417 15.3917 21.825 16.175C22.6083 16.9583 23 17.9 23 19C23 20.1 22.6083 21.0417 21.825 21.825C21.0417 22.6083 20.1 23 19 23Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.0e44558d346cf81b37d89313c826e884.svg";
export { ForwardRef as ReactComponent };